/**
 * Clears inline scroll-lock styles left on the document by modals, MUI
 * Dialog, checkout sheets, or the mobile nav menu. A full page reload drops
 * these inline styles, which is why scroll often worked only after refresh.
 */
export function releaseDocumentScrollLock() {
    const { documentElement: html, body } = document;

    html.style.removeProperty('overflow');
    html.style.removeProperty('padding-right');

    body.style.removeProperty('overflow');
    body.style.removeProperty('padding-right');
    body.style.removeProperty('position');
    body.style.removeProperty('margin-right');
    body.classList.remove('modal-open');
}

/**
 * Releases scroll immediately and again after paint / modal exit transitions.
 * Returns a cancel function for effect cleanups.
 */
export function scheduleDocumentScrollLockRelease() {
    releaseDocumentScrollLock();

    requestAnimationFrame(() => {
        releaseDocumentScrollLock();
        requestAnimationFrame(releaseDocumentScrollLock);
    });

    const delays = [50, 150, 300, 500, 800];
    const timerIds = delays.map((ms) => setTimeout(releaseDocumentScrollLock, ms));

    return () => {
        timerIds.forEach(clearTimeout);
    };
}
